import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingSku } from './types';

// Platform SKUs (no country pack) — the managed plan fee + entity/seat add-ons. Offered in the quote-line
// picker regardless of the pack being browsed.
export function useBillingPlatformSkus() {
  const { data, error, isLoading, mutate } = useSWR<TBillingSku[]>(
    'commenda-billing/catalog/platform/skus',
    SWRFetcher({ method: 'GET' })
  );

  return { skus: data ?? [], error, isLoading, mutate };
}
